import { render } from "./Individual360Report.vue?vue&type=template&id=7849bc74"
import script from "./Individual360Report.vue?vue&type=script&lang=js"
export * from "./Individual360Report.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__